import { produce } from "immer";

import { DocumentServiceFactory, EntityInstancePath } from "@com.mgmtp.a12.kernel/kernel-md-facade";
import { JSONDocument } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/models";

import { AssigneeCandidate, isAssigneeCandidate } from "../../app/slices/users/types";
import { assertTrue } from "../../utilities/assert";
import { isGroupInstance } from "../../utilities/documentHelpers";

const documentService = new DocumentServiceFactory().getDocumentService();

export function selectAssigneeFromDocument(
	document: JSONDocument,
	instancePath: EntityInstancePath
): AssigneeCandidate | undefined {
	const documentAssignee = documentService.getAssignedObject(document, instancePath);
	if (!documentAssignee) {
		return undefined;
	}

	assertTrue(isGroupInstance(documentAssignee));

	if (!documentAssignee?.id) {
		return undefined;
	}

	const assignee = produce(documentAssignee, draft => {
		draft.username = draft.id;
		delete draft.id;
	});

	assertTrue(isAssigneeCandidate(assignee));

	return assignee;
}
